import { useState } from "react";
import { api } from "../lib/api";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { formatIDR } from "../lib/translations";
import { toast } from "sonner";
import { Ticket, Check, X } from "lucide-react";
import { useI18n } from "../lib/LanguageContext";

export default function VoucherInput({ amount, scope, onApply }) {
  const { t } = useI18n();
  const [code, setCode] = useState("");
  const [applied, setApplied] = useState(null); const [loading, setLoading] = useState(false);

  const apply = async () => {
    if (!code.trim()) return;
    setLoading(true);
    try {
      const r = await api.post("/vouchers/validate", { code: code.trim(), amount, scope });
      if (r.data.reason === "ok") {
        setApplied({ code: r.data.voucher.code, discount: r.data.discount, final: r.data.final });
        onApply?.({ code: r.data.voucher.code, discount: r.data.discount });
        toast.success(`Voucher ${r.data.voucher.code}: ${t("voucher.saved")} ${formatIDR(r.data.discount)}`);
      } else {
        const msg = {
          expired: t("voucher.expired"), usage_limit_reached: t("voucher.limit"),
          min_purchase_not_met: `${t("voucher.minimum")}: ${formatIDR(r.data.voucher?.min_purchase || 0)}`,
          inactive: t("voucher.inactive"), scope_mismatch: t("voucher.scope"),
        }[r.data.reason] || t("voucher.invalid");
        toast.error(msg);
      }
    } catch (err) { toast.error(err.response?.data?.detail || t("voucher.not_found")); }
    finally { setLoading(false); }
  };
  const remove = () => { setApplied(null); setCode(""); onApply?.(null); };

  return (
    <div data-testid="voucher-input">
      {applied ? (
        <div className="flex items-center gap-2 border border-teal/25 bg-teal-soft rounded-md px-3 py-2" data-testid="voucher-applied">
          <Check className="w-4 h-4 text-teal"/>
          <div className="flex-1 text-sm">
            <span className="font-mono font-semibold text-teal">{applied.code}</span>
            <span className="text-xs text-muted-foreground ml-2">− {formatIDR(applied.discount)}</span>
          </div>
          <button onClick={remove} className="text-muted-foreground hover:text-destructive" data-testid="voucher-remove"><X className="w-4 h-4"/></button>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <div className="relative flex-1">
            <Ticket className="w-4 h-4 text-teal absolute left-3 top-1/2 -translate-y-1/2"/>
            <Input value={code} onChange={(e)=>setCode(e.target.value.toUpperCase())} placeholder={t("voucher.placeholder")} className="pl-9 uppercase" data-testid="voucher-code-input"/>
          </div>
          <Button onClick={apply} disabled={loading || !code.trim()} variant="outline" className="rounded-md border-teal text-teal" data-testid="voucher-apply-btn">{loading?"...":t("voucher.apply")}</Button>
        </div>
      )}
    </div>
  );
}
